import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import TransmissionsTableContainer from '../../../modules/transmissions/components/TransmissionsTableContainer';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import { hasPermission } from '../../../utils/HelperFunctions';
import Button from '../../../components/buttons/Button';

const Transmissions = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle } = useModuleTableHelpers({
    route: 'admin/transmissions',
    withBreadcrumb: true,
    breadcrumbTitle: t('links.transmissions'),
    withPagination: true,
    queryKey: 'transmissions'
  });

  const tableHeaders = [
    { label: t('id'), customClass: 'logo' },
    { label: t('code') },
    { label: t('name_en') },
    { label: t('description_en') },
    hasPermission(['transmissions.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="transmissions-page-container">
      <ListHeader customClass='table_filters'>
        {hasPermission(['transmissions.edit']) && <Button text={t('create_transmission')} link="/transmissions/create-transmission" />}
      </ListHeader>
      <TransmissionsTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_transmissions_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default Transmissions;
